import {
  inject,
  Pipe,
  PipeTransform,
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {IDashboardCall} from '../../models/dashboard.model';

@Pipe({
  name: 'clientName',
  pure: false,
})
export class ClientNamePipe implements PipeTransform {

  private translateService = inject(TranslateService);

  transform(row: IDashboardCall): string {
    const {client} = row;
    return client?.name ?? this.translateService.instant('front.sng.label.removed');
  }

}
